var map = {
	"./achivement-badge.svg": "2ca4",
	"./advertiser-login-as.svg": "e2b9",
	"./alert-icon.svg": "dd45",
	"./app-store.svg": "58fc",
	"./arrow-icon.svg": "76ea",
	"./arrow.svg": "21e2",
	"./as-pdf.svg": "6e9c",
	"./banner.svg": "6105",
	"./bill-icon.svg": "f44b",
	"./boostinyLogos/boostinyRedLogo.svg": "8478",
	"./boostinyLogos/boostinyWordLogo.svg": "4dc2",
	"./campaign-stats.svg": "5220",
	"./change-data-coupon.svg": "26f3",
	"./check-circle.svg": "cfcb",
	"./coupons-stat.svg": "e5ae",
	"./create-coupon.svg": "381c",
	"./down-arrow-number.svg": "c7e7",
	"./download.svg": "f28e",
	"./envelope.svg": "8e29",
	"./external-link.svg": "b64a",
	"./file-upload.svg": "402d",
	"./go-to-allocated-coupons.svg": "ce02",
	"./go-to-arrow.svg": "3236",
	"./google-login.svg": "da8f",
	"./help.svg": "acc2",
	"./huawei-store.svg": "e953",
	"./invitation.svg": "947a",
	"./last-payment.svg": "6a3e",
	"./left-arrow.svg": "6d4b",
	"./loyalty-program.svg": "1efe",
	"./minus.svg": "3e24",
	"./notif-red-icon.svg": "c2f6",
	"./partner-profile/agent-name.svg": "7468",
	"./partner-profile/araby-ads-reference.svg": "c5fb",
	"./partner-profile/basicInfo.svg": "dabb",
	"./partner-profile/categories.svg": "14fc",
	"./partner-profile/country-of-residence.svg": "8c68",
	"./partner-profile/currency-field.svg": "e3df",
	"./partner-profile/edit.svg": "4f0b",
	"./partner-profile/email.svg": "34fe",
	"./partner-profile/facebook.svg": "6604",
	"./partner-profile/gender.svg": "36c1",
	"./partner-profile/instagram.svg": "3974",
	"./partner-profile/name.svg": "9312",
	"./partner-profile/nationality.svg": "abfe",
	"./partner-profile/notes.svg": "1330",
	"./partner-profile/paymentInfo.svg": "fece",
	"./partner-profile/phone-number.svg": "1c9e",
	"./partner-profile/preferencesInfo.svg": "7594",
	"./partner-profile/profile-type.svg": "919e",
	"./partner-profile/rate-card.svg": "d485",
	"./partner-profile/rate.svg": "ce3c",
	"./partner-profile/skype.svg": "8d9c",
	"./partner-profile/snapchat.svg": "7b23",
	"./partner-profile/socialMediaInfo.svg": "58c7",
	"./partner-profile/telegram.svg": "d7e7",
	"./partner-profile/tiktok.svg": "b9f0",
	"./partner-profile/trafficSources.svg": "7daa",
	"./partner-profile/twitter.svg": "b279",
	"./partner-profile/verification-id.svg": "400a",
	"./partner-profile/whatsapp.svg": "154a",
	"./partner-profile/youtube.svg": "338a",
	"./play-store.svg": "e4e2",
	"./plus-add.svg": "2a72",
	"./plus.svg": "eb38",
	"./red-alert.svg": "639f",
	"./red-close-icon.svg": "eb7c",
	"./red-trash-icon.svg": "10db",
	"./red-uploader-icon.svg": "19bd",
	"./referral-and-loyalty/copy.svg": "0a11",
	"./referral-and-loyalty/earn.svg": "bc33",
	"./referral-and-loyalty/link-copied.svg": "5dfc",
	"./referral-and-loyalty/red-star.svg": "b1fa",
	"./referral-and-loyalty/register.svg": "655b",
	"./referral-and-loyalty/send-code.svg": "768b",
	"./register-as/influencer.svg": "64b5",
	"./register-as/publisher.svg": "2cf6",
	"./revgateLogos/icon-logo.svg": "8b07",
	"./revgateLogos/main-logo.svg": "f507",
	"./right-arrow.svg": "c686",
	"./right-red-arrow.svg": "d1aa",
	"./settings-red.svg": "1b40",
	"./settings.svg": "9174",
	"./sidebar/Partners.svg": "e6ee",
	"./sidebar/myCampaigns.svg": "68fa",
	"./sidebar/overview.svg": "83c2",
	"./sidebar/reports.svg": "2b90",
	"./sidebar/settings.svg": "76d9",
	"./sidebar/team.svg": "f984",
	"./social-accounts/facebook.svg": "22d8",
	"./social-accounts/instagram.svg": "a9aa",
	"./social-accounts/linkedIn.svg": "77a4",
	"./social-accounts/linkedin.svg": "62f9",
	"./social-accounts/pinterest.svg": "5f4d",
	"./social-accounts/skype.svg": "d5b5",
	"./social-accounts/snapchat.svg": "b0b3",
	"./social-accounts/telegram.svg": "ac64",
	"./social-accounts/tiktok.svg": "8498",
	"./social-accounts/twitter.svg": "bbee",
	"./social-accounts/whatsapp.svg": "6b7a",
	"./social-accounts/youtube.svg": "60d8",
	"./social-data.svg": "dbf3",
	"./star-rate.svg": "f609",
	"./test-notif-avatar.svg": "f113",
	"./translate.svg": "fac3",
	"./trash.svg": "af22",
	"./up-arrow-numbers.svg": "9665",
	"./uploaded-file-type-image.svg": "5934",
	"./validated-red-icon.svg": "c20b",
	"./view-list.svg": "641c",
	"./whatsapp.svg": "7583",
	"./white-star.svg": "e2e0",
	"./yellow-info-circle.svg": "4fc1"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "67f7";